import pluralize from 'pluralize';

const getRatingTitle = ({ operator, value, title = '' }) => {
  const ratingOperators = {
    between: () => `${value[0]} - ${value[1]} stars`,
    gt: () => `> ${pluralize('star', value, true)}`,
    lt: () => `< ${pluralize('star', value, true)}`,
    equals: () => `= ${pluralize('star', value, true)}`,
    notEquals: () => `≠ ${pluralize('star', value, true)}`,
    isSet: () => `${title} set`,
    notSet: () => `${title} not set`,
  };

  return ratingOperators[operator]?.() || title;
};

export default getRatingTitle;
